module.exports = __webpack_public_path__ + "static/6305-woodrose-50-cac8d5548468c3ebbb17d21d4cfe0842.jpg";